export default __webpack_public_path__ + "static/Plots0095-bd7ca660cd2ab838314f9abb7b00b57c.jpg";